
import { Component, Vue, Watch } from 'vue-property-decorator';
import { BillingPackageModel } from '@/models/billing_package';
import { RuleModel } from '@/models/rule';
import { RuleList } from '@/collections/rules';

@Component({
  components: {
  },
})
export default class BillingPackage extends Vue {
  public isLoading: boolean = true;
  public billingPackage: BillingPackageModel = new BillingPackageModel();
  public messageError: string = '';
  public isError: boolean = false;
  public rules: RuleList = new RuleList();
  public selectingRules: RuleList = new RuleList();
  public selectedRules: RuleList = new RuleList();
  public searchInput: string = '';
  public planOptions: any = [
    {
      value: 'Plus',
      text: 'Shopify Plus',
    },
    {
      value: 'Advanced',
      text: 'Advanced Shopify',
    },
    {
      value: 'Basic',
      text: 'Basic Shopify',
    },
    {
      value: 'Shopify',
      text: 'Professional',
    },
    ];

  public async created() {
    this.isLoading = false; // Set initial loading state
    this.billingPackage.id = Number(this.$route.params.id);
    await this.rules.fetch();
    
    // Sort rules by name
    this.rules.items.sort((a, b) => {
      const nameA = a.name ? a.name.toLowerCase() : '';
      const nameB = b.name ? b.name.toLowerCase() : '';
      return nameA.localeCompare(nameB);
    });
    
    this.selectingRules.items = [...this.rules.items];
    await this.billingPackage.fetch();
    console.log(this.billingPackage);
    this.selectedRules.items = [...this.billingPackage.rules.items];
  }

  public addRule() {
    const newRule = new RuleModel();
    // Initialize with default values
    newRule.id = 0; // Will be selected by user
    newRule.value = ''; // Default empty value
    
    this.selectedRules.add(newRule);
    this.billingPackage.rules.add(newRule);
  }

  public async saveBillingPackage() {
    console.log('Save button clicked!');
    try {
      // Set loading state
      this.isLoading = true;
      
      // Clear any previous errors
      this.isError = false;
      this.messageError = '';
      
      if (!this.billingPackage.name || this.billingPackage.name === '') {
        this.isError = true;
        this.messageError = 'Name is a required param';
        return;
      }

      const existedRuleIds: number[] = [];
      for (const rule of this.billingPackage.rules.items) {
        if (!existedRuleIds.includes(rule.id)) {
          existedRuleIds.push(rule.id);
        } else {
          this.isError = true;
          this.messageError = 'There are same rules in this billing package';
          return;
        }
      }

      // Ensure rules have all the necessary data from selectedRules
      this.billingPackage.rules.items = this.billingPackage.rules.items.map((rule, index) => {
        const selectedRule = this.selectedRules.items[index];
        if (selectedRule) {
          // Create a new RuleModel with all properties
          const updatedRule = new RuleModel({
            id: selectedRule.id,
            code: selectedRule.code,
            name: selectedRule.name,
            type: selectedRule.type,
            value: rule.value, // Keep the user-entered value
            initValue: selectedRule.initValue,
          });
          return updatedRule;
        }
        return rule;
      });

      // Ensure price fields are numbers
      this.billingPackage.price = Number(this.billingPackage.price) || 0;
      this.billingPackage.comparedPrice = Number(this.billingPackage.comparedPrice) || 0;

      console.log('Saving billing package with data:', {
        id: this.billingPackage.id,
        name: this.billingPackage.name,
        code: this.billingPackage.code,
        price: this.billingPackage.price,
        comparedPrice: this.billingPackage.comparedPrice,
        description: this.billingPackage.description,
        rules: this.billingPackage.rules.items,
        status: this.billingPackage.status,
        shopifyPlanName: this.billingPackage.shopifyPlanName,
      });

      await this.billingPackage.update();
      
      // Show success message
      this.$router.push('/billing_packages');
    } catch (error) {
      console.error('Error saving billing package:', error);
      this.isError = true;
      this.messageError = 'Failed to save billing package. Please try again.';
    } finally {
      // Always reset loading state
      this.isLoading = false;
    }
  }

  public async onRulesChanged(index: number) {
    for (const rule of this.rules.items) {
      if (this.selectedRules.get(index).id === rule.id) {
        const existingValue = this.billingPackage.rules.items[index].value;
        
        const newRule = new RuleModel();
        Object.assign(newRule, rule);
        
        if (existingValue !== undefined && existingValue !== null) {
          newRule.value = existingValue;
        }
        
        this.selectedRules.items[index] = newRule;
        this.billingPackage.rules.items[index] = newRule;
        
        this.$forceUpdate();
        break;
      }
    }
  }

  public customFilter(item: any, queryText: string, itemText: string) {
    if (!queryText) return true;
    
    const searchText = queryText.toLowerCase();
    const name = item.name ? item.name.toLowerCase() : '';
    const code = item.code ? item.code.toLowerCase() : '';
    
    return name.includes(searchText) || code.includes(searchText);
  }

  public deleteRule(index: number) {
    const ruleName = this.selectedRules.items[index]?.name || 'this rule';
    
    if (confirm(`Are you sure you want to delete ${ruleName}?`)) {
      // Remove from both arrays using splice
      this.selectedRules.items.splice(index, 1);
      this.billingPackage.rules.items.splice(index, 1);
      
      // Force Vue to detect the change
      this.$forceUpdate();
    }
  }
}
